import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    proposalId: Yup.number(),
    siteContact: Yup.string().nullable(),
    contactEmail: Yup.string().nullable().email("Please enter a valid email"),
    contactPhone: Yup.string().nullable(),
    contractor: Yup.string().nullable(),
    contractorPhoneNumber: Yup.string().nullable(),
    contractorAddress: Yup.string().nullable(),
    startDate: Yup.date().nullable().max(Yup.ref('estimatedCompletionDate'), "Start date must be ahead of completion date."),
    estimatedCompletionDate: Yup.date().nullable().min(Yup.ref('startDate'), "Completion date must be later than completion date."),
    estimatedNumberOfProjectManagers: Yup.string().nullable(),
    estimatedNumberOfTechnicians: Yup.string().nullable(),
    estimatedNumberOfWorkers: Yup.string().nullable(),
    jobScope: Yup.string().nullable(),
    sampleRequirements: Yup.string().nullable(),
    wastePermit: Yup.string().nullable(),
    wasterhauler: Yup.string().nullable(),
    duration: Yup.string().nullable(),
    landFill: Yup.string().nullable(),
    jobNotes: Yup.string().nullable()
});

